import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class ResetPasswordRequest {
  @jsonMember(String)
  public token!: string;

  @jsonMember(String)
  public password!: string;

  public constructor(token: string, password: string) {
    this.token = token;
    this.password = password;
  }
}
